import * as React from "react";
export const RevoMenuItemGroup = (props) => {
    return (React.createElement("div", { className: "revoMenu__group", onMouseEnter: () => props.onMouseEnter(), onMouseLeave: () => props.onMouseLeave() }, props.children));
};
export default RevoMenuItemGroup;
//# sourceMappingURL=revo-menu-item-group.js.map